module.exports = {
      id: "c8c2ace6da71f3e5f3c3229e31e55008kitchenEquipment-fitted-kitchen-with-appliances.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#c8c2ace6da71f3e5f3c3229e31e55008kitchenEquipment-fitted-kitchen-with-appliances.svg",
      toString: function () {
        return this.url;
      }
    }